import { Link, useSearchParams } from 'react-router-dom';
import { calEvents, calEventIds, isCalEventId, type CalEventId } from '../../Core/Constants/CalEvents';
import { PageHeaderPiece } from '../../Shared/Layout/Pieces';
import { CalBooking } from './CalBooking';

export const BookingComponent = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get('package') || 'signature-brand-story';
  const selectedId: CalEventId | null = isCalEventId(requested) ? requested : null;
  const selected = selectedId ? calEvents[selectedId] : null;

  return <section className="section-shell">
    <PageHeaderPiece eyebrow="Booking" title="Choose your session. Find your time."
      description="See live availability, then complete your details and secure payment on Cal.com." />
    <div className="studio-live-booking-layout">
      <div className="panel-surface studio-live-booking-panel">
        <label className="studio-package-label" htmlFor="booking-package">Session package</label>
        <select id="booking-package" className="studio-package-select" value={selectedId || ''}
          onChange={event => { const next = new URLSearchParams(searchParams); next.set('package', event.target.value); setSearchParams(next); }}>
          {!selectedId && <option value="" disabled>Choose a package</option>}
          {['Photography', 'Custom production', 'Video', 'This Is Me'].map(category => <optgroup label={category} key={category}>
            {calEventIds.filter(id => calEvents[id].category === category).map(id => <option key={id} value={id}>{calEvents[id].name} — {calEvents[id].startingPrice ? 'from ' : ''}${calEvents[id].price.toLocaleString('en-US')}</option>)}
          </optgroup>)}
        </select>
        {selectedId ? <CalBooking key={selectedId} event={selectedId} /> : <p role="alert" className="studio-booking-notice">This package does not have online scheduling. Choose a package above or <Link to="/contact">contact the studio for a custom quote</Link>.</p>}
      </div>
      <aside className="studio-booking-guide">
        <p className="cinema-eyebrow">YOUR NEXT CHAPTER</p>
        <h2>{selected?.name || 'Let’s plan your session.'}</h2>
        {selected && <p>{selected.category} · {selected.duration}</p>}
        <ol><li>Pick an available date and time.</li><li>Complete your contact and location details on Cal.com.</li><li>Pay securely through Stripe to confirm your booking.</li></ol>
        <p>Cal.com manages your confirmation, rescheduling, and cancellation options. All times shown here are Detroit time.</p>
        <p>Need extra production time or help with your project? <Link to="/contact">Talk to the studio ↗</Link></p>
        <Link className="studio-booking-review" to="/packages">Review all packages ↗</Link>
      </aside>
    </div>
  </section>;
};
